<template>
    <MainContent title="Nueva campaña de UPSELLING" subtitle="Configura las reglas y condiciones de la campaña">
        <FormUpselling
            :initialForm="localForm"
            @terminado="$router.push({ name: 'back.upselling.index' })"
        />
    </MainContent>
</template>

<script setup>
    import { ref } from 'vue'
    import MainContent from '@/modules/admin/ui/MainContent.vue'
    import FormUpselling from '@/modules/admin/upselling/FormUpselling.vue'
    import useCampaign from '@/composables/admin/upselling/useCampaign'

    const { buildInitialForm } = useCampaign()
    const localForm = ref(buildInitialForm())
</script>